import AccessWrapper from '../../components/_shared/AccessWrapper'
import { PAGES } from '../../services/constants'
import FirmwareUpdateSchedulePage from './FirmwareUpdateSchedulePage'

const FirmwareUpdateSchedule = (props) => {
  return (
    <AccessWrapper page={PAGES.deviceFirmware}>
      <FirmwareUpdateSchedulePage {...props} />
    </AccessWrapper>
  )
}

export default FirmwareUpdateSchedule
